import { render, staticRenderFns } from "./testCard.vue?vue&type=template&id=31a900a5&scoped=true"
import script from "./testCard.vue?vue&type=script&lang=js"
export * from "./testCard.vue?vue&type=script&lang=js"
import style0 from "./testCard.vue?vue&type=style&index=0&id=31a900a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a900a5",
  null
  
)

export default component.exports